import { withStyles } from '@material-ui/core';
import styles from '../styles';
import { formatMonthDateYearWithoutUTC } from '@dataGrid/gridUtilities';
import { pluralize, getStopTime } from '../../../../DriverPopUp/common/utils';
import ClosingSoonBadge from '../../../../../Common/ClosingSoonBadge';
import { inject, observer } from 'mobx-react';
import { compose } from 'recompose';
import { withAppConfig } from '../../../../../../../../appConfigContext';
import Details from './components/Details';
import { getFormattedPickupStatusToggleInfo, isUnassignedNoFreightPickup } from '../../utils';

@inject('DispatchStore')
@observer
class PickupStatusDetails extends React.Component {
  render() {
    const {
      classes,
      data,
      DispatchStore: { pickupIdToClosingTimeMapping },
      configJSON: { closingSoonWarningTimeLimit, closingSoonAlertTimeLimit, enableNoFreightCode}
    } = this.props;
    const closingSoonLimitConfig = {
      closingSoonWarningTimeLimit,
      closingSoonAlertTimeLimit
    };
    const pickupStatusToggleList = getFormattedPickupStatusToggleInfo(data);
    const stopTime = getStopTime(data.arrivalTime, data.departureTime);
    const isUnassignedNoFreight = isUnassignedNoFreightPickup(data.isNoFreight, data.driverNumber);
    return (
      <div>
        <div className={classes.statusTitleContainer}>
          <div className={classes.sectionTitle}>Pickup Status</div>
          {data.pickupId && ( //not required for past pickups
            <ClosingSoonBadge
              timeToCloseInMins={pickupIdToClosingTimeMapping[data.pickupId]}
              closingSoonLimitConfig={closingSoonLimitConfig}
            />
          )}
        </div>
        <div className={classes.infoContainer}>
          <div className={classes.statusRowContainer}>
            <Details title="Status" value={data.isNoFreight ? `${data.status} (NF)` : data.status} showBoldValue isTopSection />
            {data.isNoFreight && (
              // contactName(assigned pickup NF flow), customerName (Unassigned pickup NF flow)
              <>
              <Details title="NF Contact" value={data.contactName || data.customerName} isTopSection />
              {enableNoFreightCode && data.noFreightCode && (
                  <Details title="NF Reason Code" value={data.noFreightCode} isTopSection />
                )}
              </>
            )}
            {isUnassignedNoFreight && <Details title="Call Time" value={data.callTime} isTopSection />}
            {(data.isVoided || isUnassignedNoFreight) && <Details title="Comments" value={data.comment} isTopSection />}
            {data.isVoided && (
              <Details title="Void Reason" value={data.voidedReason} isTopSection />
            )}
          </div>
          <div className={classes.timeRowContainer}>
            <Details title="Ready Time" value={data.pickupReadyTime} />
            <Details title="Close Time" value={data.pickupCloseTime} />
            <Details
              title="Date"
              value={formatMonthDateYearWithoutUTC({ value: data.pickupDate })}
            />
            {data.driverNumber && (
              <>
                <Details title="Arr Time" value={data.arrivalTime} />
                <Details title="Dept Time" value={data.departureTime} />
                <Details
                  title="Stop Time"
                  value={stopTime ? pluralize(stopTime, 'MIN', 'S') : ''}
                />
              </>
            )}
          </div>
          {pickupStatusToggleList.length ? (
            <div className={classes.shipperLoadRowContainer}>
              {pickupStatusToggleList.map(({ label, value, ...rest }, index) => (
                <Details title={label} value={value} key={index} {...rest} />
              ))}
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default compose(withAppConfig, withStyles(styles))(PickupStatusDetails);
